import React from 'react';
import styled from '@emotion/styled';
import { useT } from 'client/i18n/hooks/useT';
import { MarketingSection } from '../../../../components/MarketingPagesShared/styles';
import {
  Title,
  List,
  Header,
  SecondaryText,
} from '../../../../components/MarketingPagesShared/ThreeColumnList';
import { SwitchVideoSection } from '../../../ImportScreen/sections/SwitchVideoSection';

const Container = styled.div`
  padding-top: 184px;
`;

const ValuePropositionTitle = styled(Title)`
  margin-top: 0;
  margin-bottom: 64px;
`;

export function ValueProposition() {
  const t = useT();
  return (
    <Container>
      <MarketingSection>
        <ValuePropositionTitle>
          {t(
            'WordpressScreen.ValueProposition.Title',
            'Powering the most podcasts worldwide. Empowering podcasters.',
            'The title for the Wordpress marketing screen'
          )}
        </ValuePropositionTitle>
      </MarketingSection>
      <SwitchVideoSection
        hideLearnMore={true}
        isFullWidth={true}
        marginBottom={[64, 50]}
        youTubeVideoId="SJCVrqqqROw"
        placeholderImagePath="wordpress/video-placeholder"
        placeholderImageAltText={t(
          'WordpressScreen.MarketingVideo.ImageAltText',
          'A dimmed video thumbnail for the video: Anchor x WordPress.com: Turn your blog into a podcast',
          'The alt text for the Wordpress marketing screen marketing video image'
        )}
        videoTitle={t(
          'WordpressScreen.MarketingVideo.Title',
          'Anchor x WordPress.com: Turn your blog into a podcast | Go beyond screens',
          'The title for the marketing video on the Wordpress marketing screen'
        )}
      />
      <MarketingSection>
        <List>
          <li>
            <Header>
              {t(
                'WordpressScreen.ValueProposition.GrowSection.Header',
                'Grow your audience',
                'The header for the grow your audience section for the Wordpress marketing screen'
              )}
            </Header>
            <SecondaryText>
              {t(
                'WordpressScreen.ValueProposition.GrowSection.Body',
                'Introduce your work and brand to new listeners, and bring your existing readers.',
                'The body for the grow your audience section for the Wordpress marketing screen'
              )}
            </SecondaryText>
          </li>
          <li>
            <Header>
              {t(
                'WordpressScreen.ValueProposition.ProcessSection.Header',
                'Seamless process',
                'The header for the grow your process section for the Wordpress marketing screen'
              )}
            </Header>
            <SecondaryText>
              {t(
                'WordpressScreen.ValueProposition.ProcessSection.Body',
                'Turning your blog into a podcast is easy—you’ve already done the hard part.',
                'The body for the grow your process section for the Wordpress marketing screen'
              )}
            </SecondaryText>
          </li>
          <li>
            <Header>
              {t(
                'WordpressScreen.ValueProposition.AudienceSection.Header',
                'Help your content resonate',
                'The header for the grow your audience section for the Wordpress marketing screen'
              )}
            </Header>
            <SecondaryText>
              {t(
                'WordpressScreen.ValueProposition.AudienceSection.Body',
                'Deepen audience engagement with a new way to express your ideas.',
                'The body for the grow your audience section for the Wordpress marketing screen'
              )}
            </SecondaryText>
          </li>
          <li>
            <Header>
              {t(
                'WordpressScreen.ValueProposition.RevenueSection.Header',
                'New revenue stream',
                'The header for the grow your revenue section for the Wordpress marketing screen'
              )}
            </Header>
            <SecondaryText>
              {t(
                'WordpressScreen.ValueProposition.RevenueSection.Body',
                'A different, growing medium means more opportunities to get paid for your work.',
                'The body for the grow your revenue section for the Wordpress marketing screen'
              )}
            </SecondaryText>
          </li>
        </List>
      </MarketingSection>
    </Container>
  );
}
